'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('./tslib.es6-f8b34207.js');
var localStore = require('./localStore.js');
var shuffle = require('lodash/shuffle');
var isNumber = require('lodash/isNumber');
var eventEmitter = require('./eventEmitter.js');
var configService = require('./configService.js');
require('./memoryStorage.js');
require('./_storageService-fcdc54f2.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var shuffle__default = /*#__PURE__*/_interopDefaultLegacy(shuffle);
var isNumber__default = /*#__PURE__*/_interopDefaultLegacy(isNumber);

var events = new eventEmitter.EventEmitter();
var ThirdLocation = /** @class */ (function (_super) {
    tslib_es6.__extends(ThirdLocation, _super);
    function ThirdLocation() {
        var _this = _super.call(this) || this;
        _this.enabled = false;
        _this.distroEndpoint = {
            prod: "distributor.ais-vidnt.com",
            stg: "stg-distributor.demo-vidnt.com",
            qa: "qa-distributor.demo-vidnt.com",
            dev: "dev-trk.vidnt.com"
        };
        _this.failedDomains = {};
        _this.events = events;
        _this.set({
            confTimestamp: 0,
            confRetryDelay: 1,
            confAttempts: 0,
            nRetries: 2,
            nNonPriorityRetries: 1,
            nDistroRetries: 3,
            fromPlayerRetry: false,
            maxReq: 4,
            domains: []
        });
        if (localStore.localStore.get('3nd_ab')) {
            _this.set('activeDomain', localStore.localStore.get('3nd_ab'));
        }
        return _this;
    }
    /**
     *
     * @param playerMode {boolean} - to use inside the player
     * */
    ThirdLocation.prototype.enable = function (playerMode) {
        if (playerMode === void 0) { playerMode = false; }
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            return tslib_es6.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.enabled = true;
                        if (!!playerMode) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.loadConf()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.healthCheck()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: return [2 /*return*/, true];
                }
            });
        });
    };
    ThirdLocation.prototype.resetConfRetries = function () {
        this.set('confRetryDelay', 1);
        this.set('confAttempts', 0);
    };
    ThirdLocation.prototype.loadConf = function () {
        return tslib_es6.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_es6.__generator(this, function (_a) {
                if (this.get('confAttempts') > this.get('nDistroRetries')) {
                    this.events.emit('retry', {
                        retryFromDistro: true
                    });
                    throw 'maxConfAttempts';
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        setTimeout(function () {
                            _this.set('confRetryDelay', _this.get('confRetryDelay') * 2);
                            _this.set('confAttempts', _this.get('confAttempts') + 1);
                            _this.failedDomains = {};
                            var response;
                            return fetch("//".concat(_this.distroEndpoint[_this.get('env')], "/distro/?d=").concat(_this.get('platform')))
                                .then(function (res) {
                                response = res;
                                return response.json();
                            })
                                .then(function (respJson) {
                                if (!response.ok) {
                                    throw respJson;
                                }
                                else {
                                    return respJson;
                                }
                            })
                                .then(function (respJson) {
                                var domains = [];
                                var conf = respJson.info.ams;
                                _this.set('nRetries', conf.n_retry || 2);
                                _this.set('nNonPriorityRetries', conf.n_non_priority_retry || 1);
                                _this.set('nDistroRetries', conf.n_distro_healthcheck_retry || 3);
                                domains.push(conf.primary);
                                domains = tslib_es6.__spreadArray(tslib_es6.__spreadArray([], domains, true), conf.secondaries, true).map(function (dom) {
                                    return dom.replace(',', '').replace('https://', '').replace('http://', '').replace('/', '');
                                });
                                _this.setActiveDomain(domains[0], true);
                                _this.set('domains', domains);
                                _this.set('confTimestamp', Date.now());
                                resolve(conf);
                            })
                                .catch(function (e) {
                                reject(e);
                            });
                        }, (_this.get('confRetryDelay') * 1000));
                    })];
            });
        });
    };
    ThirdLocation.prototype.healthCheck = function (fromFetch) {
        var _this = this;
        if (fromFetch === void 0) { fromFetch = false; }
        return new Promise(function (resolve, reject) {
            var response;
            var link = "//".concat(_this.get('activeDomain'), "/distro/healthcheck/");
            fetch("//".concat(_this.get('activeDomain'), "/distro/healthcheck/"))
                .then(function (res) {
                response = res;
                return response.json();
            })
                .then(function (respJson) {
                if (!response.ok) {
                    throw respJson;
                }
                else {
                    return respJson;
                }
            })
                .then(function (respJson) {
                _this.resetConfRetries();
                resolve(respJson);
            })
                .catch(function (error) {
                if ([403, 404, 402].indexOf(response === null || response === void 0 ? void 0 : response.status) !== -1) { // if AMS return 404
                    reject(error);
                    return;
                }
                var nextAction = _this.onBackendFailed(_this.get('activeDomain'), response === null || response === void 0 ? void 0 : response.status, null, fromFetch, link);
                if (nextAction === true) {
                    _this.healthCheck().then(resolve).catch(reject);
                }
                else if (isNumber__default["default"](nextAction)) {
                    nextAction = nextAction;
                    setTimeout(function () {
                        _this.healthCheck().then(resolve).catch(reject);
                    }, nextAction * 1000);
                }
                else if (nextAction === false) { // not found domains any more, reload conf
                    _this.loadConf().then(function () {
                        _this.healthCheck().then(resolve).catch(reject);
                    }).catch(function (e) {
                        reject(e);
                    });
                }
                else {
                    reject(error);
                }
            });
        });
    };
    ThirdLocation.prototype.connectionStatus = function (status, meta) {
        if (meta === void 0) { meta = {}; }
        this.events.emit('connection-status', tslib_es6.__assign({ status: status }, meta));
    };
    ThirdLocation.prototype.disable = function () {
        this.enabled = false;
        localStore.localStore.delete('3nd');
        localStore.localStore.delete('3nd_ab');
    };
    ThirdLocation.prototype.clearFailedDomains = function () {
        this.failedDomains = {};
    };
    ThirdLocation.prototype.isEnabled = function () {
        return this.enabled;
    };
    /**
     * @description to set current backend domain
     * */
    ThirdLocation.prototype.setActiveDomain = function (domain, isInternal) {
        if (isInternal === void 0) { isInternal = false; }
        this.set('activeDomain', domain);
        localStore.localStore.set('3nd_ab', domain);
        if (isInternal) {
            this.events.emit('updatedDomain', this.get('activeDomain'));
        }
    };
    ThirdLocation.prototype.formatLink = function (url) {
        var urlInst = new URL(url);
        urlInst.host = this.get('activeDomain');
        return urlInst;
    };
    /**
     * @param domain {String} domain which failed
     * @param httpCode {Number} http code of response
     * @param cacheState {Boolean} false - if no cache for the request, true - if record in the cache
     * @param fromFetchAms
     * @param taskUrl
     * @description to notify the module that some request filed
     * @return {string} status:
     * true - try again with calling getBackDomain;
     * null - try use response from cache,
     * false - handle the failed request as final error
     * number - (seconds) handle the same query with delay - the number of seconds
     * */
    ThirdLocation.prototype.onBackendFailed = function (domain, httpCode, cacheState, fromFetchAms, taskUrl) {
        if (httpCode === void 0) { httpCode = null; }
        if (cacheState === void 0) { cacheState = null; }
        if (fromFetchAms === void 0) { fromFetchAms = false; }
        var status;
        var maxAttempts = 1;
        var isPriority = false;
        var retryFromPlayer = false;
        var activeUrl = taskUrl;
        var priorityRequests = ['login', 'conf', 'play', 'playtemplate'];
        httpCode = httpCode || 500;
        if (activeUrl) {
            priorityRequests.forEach(function (req) {
                var parseUrl = activeUrl.split('/');
                parseUrl.forEach(function (item) {
                    if (req === item) {
                        isPriority = true;
                        if (item === 'play' || item === 'playtemplate') {
                            retryFromPlayer = true;
                        }
                    }
                });
            });
        }
        if (httpCode && httpCode === 429) {
            if (isPriority) {
                this.connectionStatus(localStore.localStore.get('connectionStatus'), { httpCode: httpCode, url: activeUrl });
            }
            if (cacheState) {
                status = null;
            }
            else {
                this.failedDomains[domain] = this.failedDomains[domain] || {
                    time: Date.now(),
                    attempts: 1,
                    delay: 0
                };
                if (taskUrl && taskUrl.includes('healthcheck')) {
                    maxAttempts = this.get('nDistroRetries');
                }
                else if (fromFetchAms) {
                    maxAttempts = isPriority ? this.get('nRetries') : this.get('nNonPriorityRetries');
                }
                if (this.failedDomains[domain].attempts <= maxAttempts) {
                    this.failedDomains[domain].attempts++;
                    this.failedDomains[domain].delay = (this.failedDomains[domain].delay ? this.failedDomains[domain].delay * 2 : 2);
                    status = this.failedDomains[domain].delay; // call again by delay
                }
                else if (fromFetchAms) {
                    if (isPriority) {
                        status = 'freeze';
                        this.events.emit('retry', {
                            retryFromPlayer: retryFromPlayer
                        });
                    }
                    else {
                        status = false; // will reload conf;
                    }
                }
            }
        }
        else if (httpCode && httpCode >= 500 && isPriority) {
            status = 'freeze';
            this.events.emit('retry', {
                retryFromPlayer: retryFromPlayer
            });
        }
        else if (fromFetchAms && Date.now() - this.get('confTimestamp') > 5000) {
            status = false; // will reload conf;
        }
        // if (status === undefined && isPriority) {
        //   onlyRetryButton = activeUrl.includes('login') || activeUrl.includes('conf')
        //   this.events.emit('thirdLocationRetry');
        // }
        if (status === undefined) {
            this.failedDomains[domain] = this.failedDomains[domain] || {
                time: Date.now()
            };
            var failedDomainsKeys_1 = Object.keys(this.failedDomains);
            var list = this.get('domains');
            var randArray = shuffle__default["default"](Object.values(list)
                .filter(function (backDom) { return failedDomainsKeys_1.indexOf(backDom) === -1; }));
            if (randArray.length) {
                this.setActiveDomain(randArray[0], true);
                status = true;
            }
            else {
                status = false;
            }
        }
        return status;
    };
    return ThirdLocation;
}(configService.ConfigService));
var thirdLocation = new ThirdLocation();

exports.thirdLocation = thirdLocation;
